module.exports = __webpack_public_path__ + "img/6-1-b.d99bc17c.jpg";